import Typography from '@eduzz/houston-ui/Typography';
import { Paper } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { CheckOutlined, ClearOutlined } from '@material-ui/icons';
import { TOOLBAR_HEIGHT } from 'components/Layout';
import React from 'react';
import { useObservable } from 'react-use-observable';
import { EHintPath } from 'v2/interfaces/hint';
import { hintFactory } from 'v2/services/hint';

import type { IHintConfig } from 'v2/interfaces/hint';

interface IHintTitle {
  hint: IHintConfig;
  key: string;
}

interface IHint {
  type: 'digital' | 'physical' | 'service';
  can?: boolean;
  cant?: boolean;
}

const Hints = ({ type, can, cant }: IHint) => {
  const [hints] = useObservable(() => hintFactory.getHints(EHintPath.NEW_PRODUCT), []);
  if (!hints?.length) return null;
  let hintsByType = hints.filter((h) => h.link === type);
  if (can) hintsByType = hintsByType.filter((h) => h.label === 'hint-can');
  if (cant) hintsByType = hintsByType.filter((h) => h.label === 'hint-cant');
  if (!hintsByType.length) return null;
  return (
    <Paper style={{ top: TOOLBAR_HEIGHT, position: 'sticky' }} elevation={0}>
      <List>
        {hintsByType.map((h) => {
          if (h.name === 'title') return <Title key={h.hint} hint={h} />;
          return <Hint key={h.hint} hint={h} />;
        })}
      </List>
    </Paper>
  );
};
const Title = ({ hint, key }: IHintTitle) => (
  <ListItem key={key}>
    <Typography size='sm'>{hint.hint}</Typography>
  </ListItem>
);

const Hint = ({ hint, key }: IHintTitle) => (
  <ListItem key={key}>
    <ListItemIcon>
      {hint.label === 'hint-can' && <CheckOutlined style={{ color: 'green' }} />}
      {hint.label === 'hint-cant' && <ClearOutlined style={{ color: 'red' }} />}
    </ListItemIcon>
    <Typography size='xxs'>{hint.hint}</Typography>
  </ListItem>
);
export default Hints;
